import { Ulid } from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import { isEqualObject } from "../utils";
import { IExpenseSettingsResponse } from "./interfaces";

const DEFAULT_EXPENSE_SETTINGS = {
    _id: Ulid.ZERO,
    id: Ulid.ZERO.toString(),
    company: "",
    enter_purchase_code: true,
    vat_mandatory: true,
};

export const makeExpense = ({ connection, company }: ApiSliceParams) => {
    const store = signal(DEFAULT_EXPENSE_SETTINGS);
    const loading = signal(false);
    const loaded = signal(false);
    let started = false;

    const view = (response: IExpenseSettingsResponse) => {
        const id = response.id ? Ulid.fromLoHi(response.id) : Ulid.ZERO;

        return {
            _id: id,
            company: response.company,
            id: id.toString(),
            enter_purchase_code: response.enter_purchase_code,
            vat_mandatory: response.vat_mandatory,
        };
    };

    const listen = async () => {
        if (started) {
            return;
        }

        const con = connection.value;

        started = true;
        loading.value = true;

        const onEnd = () => {
            loading.value = false;
            loaded.value = true;
        };

        try {
            const res = con.expense.settings({ company: company.value });
            const cached = await res.cached;

            if (cached) {
                store.value = view(cached);
                onEnd();
            }

            const current = await res.current;

            if (current) {
                const newValue = view(current);

                if (!isEqualObject(store.peek(), newValue)) {
                    store.value = newValue;
                    onEnd();
                }
            }
        } catch (err) {
            console.error(err);
        }
    };

    return {
        store,
        loading,
        listen,
    };
};
